import moment from 'moment'

const defaultDate = '0001-01-01T00:00:00'
const DATE_TIME_DISPLAY_FORMAT = 'MM/DD/YYYY hh:mm A'
export const DATE_TIME_UTC_FORMAT = 'YYYY-MM-DDTHH:mm'
const DATE_TIME_FULL_FORMAT = 'YYYY-MM-DDTHH:mm:ss'
const DATE_DISPLAY_FORMAT = 'MM/DD/YYYY'
const DATE_FORMAT = 'MM-DD-YYYY'
const TIME_FORMAT = 'hh:mm A'
const DATE_TIME_DISPLAY_FULL_FORMAT = 'MM/DD/YYYY hh:mm:ss A'

export const getCurrentTime = () => {
  return moment.utc(new Date()).format(DATE_TIME_DISPLAY_FORMAT)
}

export const convertDateToDisplayFormat = (inputDate: string) => {
  const date =
    inputDate === defaultDate
      ? moment.utc(new Date()).format(DATE_TIME_FULL_FORMAT)
      : moment.utc(inputDate).format(DATE_TIME_FULL_FORMAT)

  const stillUtc = moment.utc(date, DATE_TIME_FULL_FORMAT).toDate()
  return moment(stillUtc, DATE_TIME_FULL_FORMAT)
    .local()
    .format(DATE_DISPLAY_FORMAT)
}

export const convertDateToLocal = (inputDate: string) => {
  const date =
    inputDate === defaultDate
      ? moment.utc(new Date()).format(DATE_FORMAT)
      : moment.utc(inputDate).format(DATE_FORMAT)

  const stillUtc = moment.utc(date, DATE_FORMAT).toDate()
  return moment(stillUtc, DATE_FORMAT).local().format(DATE_DISPLAY_FORMAT)
}

export const convertTimeToLocalDisplayFormat = (inputDateTime: string) => {
  const date =
    inputDateTime === defaultDate
      ? moment.utc(new Date()).format(DATE_TIME_DISPLAY_FORMAT)
      : moment.utc(inputDateTime).format(DATE_TIME_DISPLAY_FORMAT)
  const stillUtc = moment.utc(date, DATE_TIME_DISPLAY_FORMAT).toDate()
  return moment(stillUtc, DATE_TIME_DISPLAY_FORMAT).local().format(TIME_FORMAT)
}

export const hoursAndMinutesToMinutes = (timeInHour: string) => {
  const timeParts: string[] = timeInHour?.split(':')
  return Number(timeParts[0]) * 60 + Number(timeParts[1])
}

export const hoursMinutes = (totalMinutes: any) => {
  const input = totalMinutes || 0
  const hours = Math.floor(input / 60)
  const minutes = Math.floor(input % 60)
  return hours + ': ' + minutes
}

export const convertDateTimeFullFormatToLocal = (inputDate: string) => {
  const date =
    inputDate === defaultDate
      ? moment.utc(new Date()).format(DATE_TIME_FULL_FORMAT)
      : moment.utc(inputDate).format(DATE_TIME_FULL_FORMAT)

  const stillUtc = moment.utc(date, DATE_TIME_FULL_FORMAT).toDate()
  return moment(stillUtc, DATE_TIME_FULL_FORMAT)
    .local()
    .format(DATE_TIME_DISPLAY_FULL_FORMAT)
}
